module.exports = __webpack_public_path__ + "img/banner_bg.97a7a3e9.png";